<div class="threads mt-3 pt-3">
    @if(threads?.length + threadsLimitTo > 0){
        <div class="threads-more ps-3 pb-2"
            (click)="showMore()">{{ 'comment-card.show_more' | translate}}...
        </div>
    }

    @for(thread of threads?.slice(threadsLimitTo); track thread.id){
        <div class="media thread-node bg-transparent">
            @if(thread.moderationStatus !== 'thread_moderation_under_review'){
                <tm-thread-message class="d-flex w-100"
                                [threadAuthors]="$safeNavigationMigration(timelineItem?.threadAuthors)"
                                [thread]="thread"
                                [timelineItemId]="$safeNavigationMigration(timelineItem?.id)"
                                (onThreadDeleted)="deleteThread($event)"
                                (onThreadReported)="moderateThread($event)"
                                (onThreadEdited)="onEditedThread($event)"></tm-thread-message>

                 <thread-reactions [timelineItem]="timelineItem"
                                   [thread]="thread"
                                   (onThreadReactionsUpdated)="onThreadReactionsUpdated($event)"></thread-reactions>
            } 
            @else {
                <tm-thread-message-under-moderation [thread]="thread"></tm-thread-message-under-moderation>
            }
        </div>
    }

    <tm-thread-input-area
            [thread]="newThread"
            [threadAuthors]="$safeNavigationMigration(timelineItem?.threadAuthors)"
            [userInfos]="userInfos"
            (onThreadAdded)="onThreadAdded($event)"
            (onCancelUpdates)="onCancel()"
            [setFocus]="discuss" #newThreadComponent></tm-thread-input-area>
</div>